import script from "./FreightInfoDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./FreightInfoDialog.vue?vue&type=script&lang=ts&setup=true"

import "./FreightInfoDialog.vue?vue&type=style&index=0&id=3844d146&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3844d146"]])

export default __exports__